const nested={User:{fields:{agent:{type:"string",id:1},env:{type:"string",id:2},browser:{type:"string",id:3},browser_version:{type:"string",id:4},os_type:{type:"string",id:5},system_version:{type:"string",id:6},device_type:{type:"string",id:7},device_model:{type:"string",id:8},app_version:{type:"string",id:9},app_build_code:{type:"string",id:10},version:{type:"string",id:11}}},Logs:{fields:{messages:{rule:"required",type:"string",id:1},level:{rule:"required",type:"int32",id:2},path:{rule:"required",type:"string",id:3},reqId:{rule:"required",type:"string",id:4},user_id:{type:"string",id:5},source:{type:"int32",id:6},t:{type:"string",id:7}}},Queue:{fields:{project:{type:"string",id:1},user:{type:"User",id:2},logs:{rule:"repeated",type:"Logs",id:3}}}};var json = {nested:nested};

const dynamicLoadScript = (src, object, callback) => {
  const existingScript = document.getElementById(src);
  const cb = callback || function() {};

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = src; // src url for the third-party library being loaded.
    script.id = src;
    document.body.appendChild(script);
    const onEnd = 'onload' in script ? stdOnEnd : ieOnEnd;
    onEnd(script);
  }

  if (existingScript && cb && object) {
    cb(null, existingScript);
  }

  function stdOnEnd(script) {
    script.onload = function() {
      // this.onload = null here is necessary
      // because even IE9 works not like others
      this.onerror = this.onload = null;
      cb(null, script);
    };
    script.onerror = function() {
      this.onerror = this.onload = null;
      cb(new Error('Failed to load ' + src), script);
    };
  }

  function ieOnEnd(script) {
    script.onreadystatechange = function() {
      if (this.readyState !== 'complete' && this.readyState !== 'loaded') return
      this.onreadystatechange = null;
      cb(null, script);
    };
  }
};

// @ts-nocheck
const version = '1.3.2';
class ReportLog {
    constructor(conf) {
        /**
         * console
         */
        this.originalConsole = null;
        /**
         * 配置文件
         */
        this.config = {
            logging: true,
            url: '/',
            transports: ['websocket'],
            cdn: {
                protobuf: 'https://cdn.jsdelivr.net/gh/dcodeIO/protobuf.js@6.X.X/dist/protobuf.min.js',
                socket: 'https://cdn.socket.io/4.5.0/socket.io.min.js'
            }
        };
        /**
         * 上报计时器
         */
        this.timer = null;
        /**
         * 日志发送间隔，可根据云配置调整
         */
        this.interval = 10;
        /**
         * 是否记录日志，默认记录日志，如果获取到配置是不上报，立即关闭记录并清除queueList，反之打开记录，可根据云配置调整
         */
        this.isRecord = true;
        /**
         * 是否上报，可根据云配置调整
         */
        this.isReport = false;
        /**
         * 是否上报所有的网络请求，默认只上报错误的，可根据云配置调整
         */
        this.isReportAllRequest = false;
        /**
         * 上报所有console，用于查看某些用户的所有日志输出，可根据云配置调整
         */
        this.isReportAllLog = true;
        /**
         * 过滤请求的关键字，逗号分割，可根据云配置调整
         */
        this.ignoreUrl = ['agora', 'sd-rtn'];
        /**
         * 过滤object的关键字，如果上报数据中有较大的对象，建议忽略，逗号分割，可根据云配置调整
         * 这个参数只会将匹配的字段进行格式化成Boolean，用于表达是否存在，具体看<驯服循环引用的对象>函数
         */
        this.ignoreKey = 'rtc,rtm';
        /**
         * 最后一次发送时间，用于计算一下次发送时间
         */
        this.report_time = new Date().getTime();
        /**
         * 日志队列
         */
        this.queueList = [];
        /**
         * socket
         */
        this.socket = null;
        /**
         * 压缩
         */
        this.protobufQueue = null;
        // xhr 原生 open 方法
        this.xhrOpen = XMLHttpRequest.prototype.open;
        // xhr 原生 send 方法
        this.xhrSend = XMLHttpRequest.prototype.send;
        this.countReset = () => { };
        this.timeLog = () => { };
        this.originalConsole = window.console;
        const { cdn } = conf;
        // 某些项目使用解构加载白屏，why?
        this.config = Object.assign(this.config, conf);
        const cdns = Object.assign(this.config.cdn, cdn);
        // this.config = {
        //   ...this.config,
        //   ...conf
        // }
        // const cdns = {
        //   ...this.config.cdn,
        //   ...cdn
        // }
        this.initLoad();
        new Promise(resolve => {
            let protobufLoad = false, socketIoLoad = false;
            dynamicLoadScript(cdns.protobuf, window.protobuf, err => {
                if (err) {
                    this.originalConsole.error(err.message);
                    return;
                }
                const root = window.protobuf.Root.fromJSON(json);
                this.protobufQueue = root.lookupType('Queue');
                protobufLoad = true;
                if (protobufLoad && socketIoLoad) {
                    resolve();
                }
            });
            dynamicLoadScript(cdns.socket, window.io, err => {
                if (err) {
                    this.originalConsole.error(err.message);
                    return;
                }
                // 连接socket
                this.socket = window.io(this.config.url, {
                    path: '/report-log',
                    transports: this.config.transports,
                    query: {
                        project: this.config.project,
                        req_id: this.getReqId(),
                        version,
                        t: new Date().getTime(),
                        user_id: localStorage.report_user_id
                    }
                });
                socketIoLoad = true;
                if (protobufLoad && socketIoLoad) {
                    resolve();
                }
            });
        }).then(() => {
            this.init();
        });
    }
    get report() {
        if (this.isRecord) {
            return this._report.bind(this);
        }
        return this.originalConsole.log;
    }
    get log() {
        if (this.isRecord && this.isReportAllLog) {
            return this._log.bind(this);
        }
        return this.originalConsole.log;
    }
    get info() {
        if (this.isRecord && this.isReportAllLog) {
            return this._info.bind(this);
        }
        return this.originalConsole.info;
    }
    get warn() {
        if (this.isRecord && this.isReportAllLog) {
            return this._warn.bind(this);
        }
        return this.originalConsole.warn;
    }
    get error() {
        if (this.isRecord && this.isReportAllLog) {
            return this._error.bind(this);
        }
        return this.originalConsole.error;
    }
    get debug() {
        return this.originalConsole.debug;
    }
    get memory() {
        return this.originalConsole.memory;
    }
    get assert() {
        return this.originalConsole.assert;
    }
    get clear() {
        return this.originalConsole.clear;
    }
    get count() {
        return this.originalConsole.count;
    }
    get dir() {
        return this.originalConsole.dir;
    }
    get dirxml() {
        return this.originalConsole.dirxml;
    }
    get exception() {
        return this.originalConsole.exception;
    }
    get group() {
        return this.originalConsole.group;
    }
    get groupCollapsed() {
        return this.originalConsole.groupCollapsed;
    }
    get groupEnd() {
        return this.originalConsole.groupEnd;
    }
    get markTimeline() {
        return this.originalConsole.markTimeline;
    }
    get msIsIndependentlyComposed() {
        return this.originalConsole.msIsIndependentlyComposed;
    }
    get profile() {
        return this.originalConsole.profile;
    }
    get profileEnd() {
        return this.originalConsole.profileEnd;
    }
    get select() {
        return this.originalConsole.select;
    }
    get table() {
        return this.originalConsole.table;
    }
    get time() {
        return this.originalConsole.time;
    }
    get timeEnd() {
        return this.originalConsole.timeEnd;
    }
    get timeStamp() {
        return this.originalConsole.timeStamp;
    }
    get timeline() {
        return this.originalConsole.timeline;
    }
    get timelineEnd() {
        return this.originalConsole.timelineEnd;
    }
    get trace() {
        return this.originalConsole.trace;
    }
    /**
     * 添加记录
     * @param messages
     * @param level
     * @param source 0 默认 1 来源原生console
     */
    pushQueue(messages, level, source = 0) {
        const msg = JSON.stringify(messages, this.getCircularReplacer());
        if (this.isRecord && !this.ignoreKeyword || this.ignoreKeyword.length === 0 || this.ignoreKeyword.find(v => !msg.includes(v))) {
            this.queueList.push({
                messages: msg,
                level,
                path: window.location.href,
                reqId: this.getReqId(),
                user_id: localStorage.report_user_id,
                source,
                t: `${new Date().getTime()}`
            });
        }
    }
    _report(...agrs) {
        this.pushQueue([...agrs], 0);
        this.originalConsole.log(...agrs);
    }
    _log(...agrs) {
        this.pushQueue([...agrs], 0, 1);
        this.originalConsole.log(...agrs);
    }
    _info(...agrs) {
        this.pushQueue([...agrs], 1, 1);
        this.originalConsole.info(...agrs);
    }
    _warn(...agrs) {
        this.pushQueue([...agrs], 2, 1);
        this.originalConsole.warn(...agrs);
    }
    _error(...agrs) {
        this.pushQueue([...agrs], 3, 1);
        this.originalConsole.error(...agrs);
    }
    /**
     * 初始化页面访问监听/网络问题
     * 记录load、pushState、popstate
     */
    initLoad() {
        const bindEventListener = function (type) {
            const historyEvent = history[type];
            return function () {
                const newEvent = historyEvent.apply(this, arguments);
                const e = new Event(type);
                e.arguments = arguments;
                window.dispatchEvent(e);
                return newEvent;
            };
        };
        // 创建能监听页面前进和替换的状态
        history.pushState = bindEventListener('pushState');
        history.replaceState = bindEventListener('replaceState');
        // window.addEventListener('replaceState', (e) => {
        //   console.log('replaceState', e)
        // })
        // 页面前进
        window.addEventListener('pushState', () => {
            this.pushQueue(['pushState'], 0);
        });
        // 页面hash变化、History变化
        window.addEventListener('popstate', () => {
            this.pushQueue(['popstate'], 0);
        });
        // 页面hash变化
        // window.addEventListener('hashchange', (e) => {
        //   console.log('hashchange', e)
        // })
        // 页面加载
        window.addEventListener('load', () => {
            this.pushQueue(['load'], 0);
        });
        // 网络连接（无法监听变化）
        window.addEventListener('online', () => {
            this.pushQueue(['online'], 0);
        });
        // 网络断开（无法监听vpn类型、无法监听变化）
        window.addEventListener('offline', () => {
            this.pushQueue(['offline'], 2);
        });
        let isClose = false;
        const close = (event) => {
            if (!isClose) {
                isClose = true;
                this.pushQueue([event], 0);
                this.send();
                this.timer && clearInterval(this.timer);
            }
        };
        // 页面关闭日志和关闭前没发的日志问题，暂时没好的办法
        // 这里有一个博文可以参考，说使用navigator.sendBeacon可以发送，可是我TM使用的是socket来发呀！！！后续再说
        // https://cloud.tencent.com/developer/article/1875514
        // 页面关闭，大部分兼容
        window.addEventListener('beforeunload', () => {
            close('beforeunload');
        });
        // 页面关闭，大部分兼容
        window.addEventListener('pagehide', () => {
            close('pagehide');
        });
        // 页面关闭，大部分兼容
        window.addEventListener('unload', () => {
            close('unload');
        });
    }
    /**
     * 初始化拦截器
     */
    async init() {
        this.originalConsole.log(`%c[RL] 🚀 项目:[${this.config.project}] 前端日志模块:[v${version}] 加载完成~`, 'color: #2196f3');
        // 自动记录异常
        this.exceptionHandler();
        // 自动记录 ajax 请求
        this.ajaxHandler();
        // 获取配置
        await this.getProjectConf();
        // 上报首屏资源状态
        this.performanceGetEntries();
        // 监听动态配置修改
        this.socket.on('change-project-conf', res => {
            const data = JSON.parse(res);
            this.changeConf(data);
        });
        // 监听动态配置修改
        this.socket.on('change-user-conf', res => {
            const data = JSON.parse(res);
            this.changeConf(data);
        });
        this.loopClock();
    }
    /**
     * 定时上报
     */
    loopClock() {
        this.timer && clearInterval(this.timer);
        this.timer = setInterval(() => {
            this.send();
        }, this.interval * 1000);
    }
    /**
     * 上报首屏资源状态
     * @returns
     */
    performanceGetEntries() {
        // 判断浏览器是否支持
        if (!window.performance || !window.performance.getEntriesByType) {
            this.pushQueue([`浏览器不支持performance，无法上报首屏资源状态`], 1, 1);
            return false;
        }
        let result = [];
        const resource = window.performance.getEntriesByType('resource');
        resource.forEach(item => {
            if (item.name) {
                const name = item.name || '';
                result.push(name.split('?')[0]);
            }
        });
        this.pushQueue([`首屏加载${resource.length}个资源`, result], 1, 1);
    }
    /**
     * 自动记录异常
     * @memberof Lajax
     */
    exceptionHandler() {
        // 页面未捕获异常
        window.addEventListener('error', err => {
            if (this.isRecord) {
                let target = err.target || err.srcElement;
                let isElementTarget = target instanceof HTMLElement;
                if (!isElementTarget) {
                    this.pushQueue(['[OnError]', err.message, `(${err.lineno}行${err.colno}列)`], 3);
                }
                else {
                    this.originalConsole.log(err);
                    this.pushQueue([
                        '资源加载警告',
                        `捕获${target.outerHTML || ''}加载资源出错`
                    ], 1);
                }
            }
        }, true);
        // Promise 未捕获异常
        window.addEventListener('unhandledrejection', err => {
            if (this.isRecord) {
                this.pushQueue(['[OnRejection]', err.reason && err.reason.stack ? err.reason.stack : 'Promise异常'], 3);
            }
        });
    }
    /**
     * 解析 url -> 方法真不错
     * @param {string} url
     * @returns
     * @memberof Lajax
     */
    resolveUrl(url) {
        const link = document.createElement('a');
        link.href = url;
        return `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
    }
    /**
     * 自动记录 ajax 请求
     * @memberof Lajax
     */
    ajaxHandler() {
        const that = this;
        // 重写 open 方法
        XMLHttpRequest.prototype.open = function (...args) {
            this._lajaxMethod = args[0];
            this._lajaxUrl = that.resolveUrl(args[1]);
            that.xhrOpen.apply(this, args);
        };
        // 重写 send 方法
        XMLHttpRequest.prototype.send = function (data) {
            // 请求开始时间
            const startTime = new Date();
            // 排除掉用户自定义不需要记录日志的 ajax
            const isIgnoreUrl = that.logAjaxFilter(this._lajaxUrl, this._lajaxMethod) && that.isReportAllRequest;
            if (isIgnoreUrl) {
                // 添加一条日志到队列中
                that.pushQueue([`[ajax] 发送${this._lajaxMethod.toLowerCase()}请求：${this._lajaxUrl}`], 0);
            }
            // 添加 readystatechange 事件
            this.addEventListener('readystatechange', function () {
                // 排除掉用户自定义不需要记录日志的 ajax
                if (that.logAjaxFilter(this._lajaxUrl, this._lajaxMethod)) {
                    try {
                        if (this.readyState === XMLHttpRequest.DONE) {
                            // 请求结束时间
                            const endTime = new Date();
                            // 请求耗时
                            const costTime = (endTime - startTime) / 1000;
                            const msgs = [];
                            if (this.status >= 200 && this.status < 400) {
                                msgs.push('接口请求成功。');
                            }
                            else {
                                msgs.push('接口请求失败！');
                            }
                            msgs.push(`请求耗时：${costTime}s URL：${this._lajaxUrl} 请求方式：${this._lajaxMethod}`);
                            if (this._lajaxMethod.toLowerCase() === 'post') {
                                msgs.push('表单数据：', data);
                            }
                            msgs.push(`状态码：${this.status}`);
                            if (this.status >= 200 && this.status < 400) {
                                if (isIgnoreUrl) {
                                    that.pushQueue(['[ajax]', ...msgs], 0);
                                }
                            }
                            else {
                                that.pushQueue(['[ajax]', ...msgs], 3);
                            }
                        }
                    }
                    catch (err) {
                        const msgs = [];
                        msgs.push('接口请求出错！');
                        msgs.push(`URL：${this._lajaxUrl} 请求方式：${this._lajaxMethod}`);
                        if (this._lajaxMethod.toLowerCase() === 'post') {
                            msgs.push('表单数据：', data);
                        }
                        msgs.push(`状态码：${this.status}`);
                        msgs.push(`ERROR：${err}`);
                        that.pushQueue(['[ajax]', ...msgs], 3);
                    }
                }
            });
            that.xhrSend.call(this, data);
        };
    }
    /**
     * 获取项目的云配置
     */
    getProjectConf() {
        return new Promise((resolve, reject) => {
            this.socket.emit('get-project-info', '', res => {
                const data = JSON.parse(res);
                this.changeConf(data);
                resolve();
            });
        });
    }
    /**
     * 修改配置
     * @param data
     */
    changeConf(data) {
        // this.originalConsole.log(data)
        const { isReport = undefined, isReportAllRequest = undefined, isReportAllLog = undefined, ignoreUrl = undefined, ignoreKeyword = undefined, ignoreKey = undefined, interval = undefined } = data;
        this.isReport = isReport !== undefined ? isReport : this.isReport;
        if (!this.isReport) {
            this.queueList = [];
        }
        this.isRecord = isReport !== undefined ? isReport : this.isRecord;
        this.isReportAllRequest =
            isReportAllRequest !== undefined ? isReportAllRequest : this.isReportAllRequest;
        this.isReportAllLog = isReportAllLog !== undefined ? isReportAllLog : this.isReportAllLog;
        this.ignoreUrl = ignoreUrl !== undefined ? ignoreUrl : this.ignoreUrl;
        this.ignoreKey = ignoreKey !== undefined ? ignoreKey : this.ignoreKey;
        this.ignoreKeyword = ignoreKeyword !== undefined ? ignoreKeyword : this.ignoreKeyword;
        this.interval = interval !== undefined ? interval : this.interval;
        this.originalConsole.log(`%c[RL] 📖 上报:${this.isReport ? '[开]' : '[关]'} 上报所有:${this.isReportAllLog ? '[开]' : '[关]'} 上报网络请求:${this.isReportAllRequest ? '[所有]' : '[仅错误]'} 过滤请求:[${this.ignoreUrl}] 过滤数据:[${this.ignoreKeyword}] 简化数据:[${this.ignoreKey}] socket_id:[${this.socket.id}] req_id:[${this.getReqId()}] 间隔:${this.interval}s`, 'color: #2196f3');
        this.loopClock();
    }
    /**
     * 过滤函数
     * @param url 请求地址
     * @returns 返回TRUE、FALSE
     */
    logAjaxFilter(url) {
        if (this.ignoreUrl.filter(v => url.includes(v)).length) {
            return false;
        }
        return true;
    }
    /**
     * 获取系统生成ID、唯一ID，用于未绑定用户ID区分用户
     */
    getReqId() {
        let reqId = window.reqId;
        if (!reqId) {
            reqId = localStorage.reqId;
        }
        if (!reqId) {
            let time = Date.now();
            if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
                // 使用更高精度的时间
                time += performance.now();
            }
            reqId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
                const rand = (time + Math.random() * 16) % 16 | 0;
                time = Math.floor(time / 16);
                return (char === 'x' ? rand : (rand & 0x3) | 0x8).toString(16);
            });
        }
        localStorage.reqId = reqId;
        return reqId;
    }
    /**
     * 驯服循环引用的对象
     * @returns {(function(*=, *=): (undefined|boolean))|*}
     * @private
     */
    getCircularReplacer() {
        const seen = new WeakSet();
        return (key, value) => {
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                    return;
                }
                if (key && this.ignoreKey.includes(key)) {
                    return !!value;
                }
                else {
                    seen.add(value);
                }
            }
            return value;
        };
    }
    /**
     * 上报
     */
    send() {
        if (this.isReport) {
            const logs = [...this.queueList];
            if (logs.length) {
                const reportLogs = logs.filter(v => v.source === 0 || this.isReportAllLog);
                const fixQueueList = {
                    logs: reportLogs,
                };
                // 序列化
                const buff = this.protobufQueue.encode(this.protobufQueue.create(fixQueueList)).finish();
                this.socket.emit('report-logs-info', buff, res => {
                    // 显示日志发送成功
                    this.config.logging &&
                        this.originalConsole.log(`%c[RL] ⬆️ ${reportLogs.length}条日志上报成功！`, 'color: #2196f3');
                });
                // 日志发送成功，从队列中去除已发送的
                this.queueList.splice(0, logs.length);
            }
        }
    }
}

export { ReportLog };
//# sourceMappingURL=log.esm.js.map
